module.exports = __webpack_public_path__ + "static/media/prototype.8b0fd520.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/power-grip-dragoons/prototype.gif
// module id = 803
// module chunks = 0